import { render, staticRenderFns } from "./clausula.vue?vue&type=template&id=13846248"
import script from "./clausula.vue?vue&type=script&lang=js"
export * from "./clausula.vue?vue&type=script&lang=js"
import style0 from "./clausula.vue?vue&type=style&index=0&id=13846248&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports